import CircularProgress from "@material-ui/core/CircularProgress";
import { ArrowBack, Delete } from "@material-ui/icons";
import SaveIcon from "@material-ui/icons/Save";
import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import * as yup from "yup";
import fetchClient from "../../api/fetchClient";
import Tabs from "../../components/concur/Tabs";
import { DEFAULT_CURRENCIES } from "../../components/concur/TabCurrencies";
import message from "../../helper/message";
import {
    ModernContainer,
    ModernHeader,
    HeaderLeft,
    HeaderTitle,
    BackButton,
    ActionBar,
    ActionGroup,
    ActionButton,
    ContentCard,
    Form,
    getTheme,
} from "../../components/common";

const validationSchema = yup.object({
  id: yup.string("Informe o id").required("Id é obrigatório"),
  name: yup
    .string("Informe o nome da credencial")
    .required("Nome é obrigatório"),
  description: yup
    .string("Informe a descrição")
    .required("Descrição é obrigatório"),
  client_id: yup
    .string("Informe o código do cliente")
    .required("Código do cliente é obrigatório"),
  client_secret: yup
    .string("Informe o código secreto")
    .required("Código secreto é obrigatório"),
  url: yup.string("Informe a url").required("Url é obrigatório"),
});

function Concur(props) {
  const { data, isViewing } = props;
  const theme = getTheme('concur');

  const [concur, setConcur] = useState(data);
  const [error, setError] = useState(false);

  const onSave = async (concur) => {
    console.log(concur);
    try {
      if (!concur.empresa)
        return message.error("Selecione uma empresa na aba Empresas antes de salvar.");
      if (Number(concur.rate) < 30)
        throw new Error(
          "O Rate de execução não pode ser menor que 30 minutos!"
        );
      await fetchClient.post("createConcur", concur);
      // getAllConcur();
      message.sucess("Salvo com sucesso!");
      isViewing(false);
    } catch (error) {
      const msg = error.response?.data?.message || error.message;
      message.error(msg);
    }
  };

  const onDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Tem certeza que deseja deletar esta configuração? Esta ação não pode ser desfeita."
    );

    if (!confirmDelete) return;

    try {
      await fetchClient.delete(`deleteConcur/${id}`);
      isViewing(false);
      message.sucess("Registro deletado com sucesso");
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  const defaultValues = {
    id: concur.id,
    name: concur.name,
    description: concur.description,
    client_id: concur.client_id,
    client_secret: concur.client_secret,
    url: concur.url,
    username: concur.username,
    refresh_token: concur.refresh_token ? concur.refresh_token : "",
    geo_location: concur.geo_location ? concur.geo_location : "",
    refresh_expires_in: concur.refresh_expires_in
      ? concur.refresh_expires_in
      : "",
    empresa: concur.empresa,
    "contracted-expense": concur["contracted-expense"] || 0,
    "contracted-cash": concur["contracted-cash"] || 0,
    rate: concur["rate"] || 30,
    "mapping-expense": concur["mapping-expense"] || [],
    "mapping-cash": concur["mapping-cash"] || [],
    "mapping-nfe-expense": concur["mapping-nfe-expense"] || [],
    "mapping-nfe-cash": concur["mapping-nfe-cash"] || [],
    "mapping-lc-expense": concur["mapping-lc-expense"] || [],
    "mapping-lc-cash": concur["mapping-lc-cash"] || [],
    sendAttachments: concur.sendAttachments || true,
    ativo: concur.ativo,
    maxEmpresas: concur.maxEmpresas || 0,
    "rule-adiantamento": concur["rule-adiantamento"],
    "rule-entrada": concur["rule-entrada"],
    "rule-lcm": concur["rule-lcm"],
    "rule-card": concur["rule-card"],
    "ruleValue-adiantamento": concur["ruleValue-adiantamento"],
    "ruleValue-entrada": concur["ruleValue-entrada"],
    "ruleValue-lcm": concur["ruleValue-lcm"],
    "ruleValue-card": concur["ruleValue-card"],
    access_token: concur.access_token,
    currencies: concur.currencies?.length > 0 ? concur.currencies : DEFAULT_CURRENCIES,
  };

  const formik = useFormik({
    initialValues: defaultValues,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, actions) => {
      await onSave(values, actions);
    },
  });

  const {
    touched,
    values,
    errors,
    handleChange,
    handleSubmit,
    isSubmitting,
    setFieldValue,
  } = formik;

  if (error) return null;
  return (
    <FormikProvider value={formik}>
      <ModernContainer>
        <ModernHeader>
          <HeaderLeft>
            <BackButton color={theme.primary} onClick={() => isViewing(false)}>
              <ArrowBack />
            </BackButton>
            <HeaderTitle>
              {concur.newConcur ? "Nova Configuração Concur" : values.name || "Editar Configuração"}
            </HeaderTitle>
          </HeaderLeft>
          <ConnectionStatus active={values.ativo}>
            {values.ativo ? "Ativo" : "Inativo"}
          </ConnectionStatus>
        </ModernHeader>

        <ActionBar>
          <ActionGroup>
            <ActionButton
              variant="danger"
              disabled={concur.newConcur}
              onClick={async () => await onDelete(concur.id)}
            >
              <Delete style={{ marginRight: '8px', fontSize: '20px' }} />
              Deletar
            </ActionButton>

            <ActionButton
              variant="primary"
              onClick={handleSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={20} style={{ marginRight: '8px', color: 'white' }} />
              ) : (
                <SaveIcon style={{ marginRight: '8px', fontSize: '20px' }} />
              )}
              Salvar
            </ActionButton>
          </ActionGroup>
        </ActionBar>

        <ContentCard>
          <Form autoComplete="off">
            <Tabs
              values={values}
              touched={touched}
              errors={errors}
              handleChange={handleChange}
              setFieldValue={setFieldValue}
              formik={formik}
            />
          </Form>
        </ContentCard>
      </ModernContainer>
    </FormikProvider>
  );
}

export default Concur;

const ConnectionStatus = styled.div`
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  ${({ active }) =>
    active
      ? `
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
  `
      : `
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
  `}
`;
